import { useState, useEffect } from 'react';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import HorizontalRuleIcon from '@mui/icons-material/HorizontalRule';
import { getCompletedDataLabel, getMomentDate } from '../../../../utils/getDate';

const useEngagementSection = ({ monthData, weekData }) => {
  const [recentMonth, setRecentMonth] = useState(0);
  const [monthDiff, setMonthDiff] = useState(0);
  const [weekDiff, setWeekDiff] = useState(0);
  const [recentWeek, setRecentWeek] = useState(0);
  const [monthOp, setMonthOp] = useState('~');
  const [weekOp, setWeekOp] = useState('~');

  useEffect(() => {
    const keys = Object.keys(monthData ?? {}) || [];
    const completedDate = getCompletedDataLabel(keys, 'month') ?? '';
    const completedMonth = monthData?.[completedDate] ?? 0;
    const secondLastMonth = monthData?.[getMomentDate(completedDate)?.subtract(1, 'months').format('MM-YYYY')] ?? 0;
    setRecentMonth(completedMonth);
    if ((secondLastMonth === 0 && completedMonth === 0) || (secondLastMonth === completedMonth)) {
      setMonthOp('~');
    }
    if (secondLastMonth > completedMonth) {
      setMonthOp('-');
      setMonthDiff(secondLastMonth - completedMonth);
    }
    if (secondLastMonth < completedMonth) {
      setMonthOp('+');
      setMonthDiff(completedMonth - secondLastMonth);
    }
  }, [monthData]);

  useEffect(() => {
    const keys = Object.keys(weekData || {}) || [];
    const completedDate = getCompletedDataLabel(keys, 'week');
    const completedWeek = weekData?.[completedDate] || 0;
    const secondLastWeek = weekData?.[getMomentDate(completedDate).subtract(7, 'days').format('MM-DD-YYYY')] || 0;
    setRecentWeek(completedWeek);

    if ((secondLastWeek === 0 && completedWeek === 0) || (secondLastWeek === completedWeek)) {
      setWeekOp('~');
    }
    if (secondLastWeek > completedWeek) {
      setWeekOp('-');
      setWeekDiff(secondLastWeek - completedWeek);
    }
    if (secondLastWeek < completedWeek) {
      setWeekOp('+');
      setWeekDiff(completedWeek - secondLastWeek);
    }
  }, [weekData]);

  const opObject = {
    '+': <KeyboardArrowUpIcon style={{ color: 'green', width: '0.9em', display: 'inline-table' }} />,
    '-': <KeyboardArrowDownIcon style={{ color: 'red', width: '0.9em', display: 'inline-table' }} />,
    '~': <HorizontalRuleIcon style={{ color: 'grey', width: '0.6em', display: 'inline-table' }} />,
  };

  return {
    recentMonth,
    recentWeek,
    monthOp,
    weekOp,
    opObject,
    monthDiff,
    weekDiff,
  };
};

export default useEngagementSection;
